import React from "react";

export default function NotAvailable() {
  return (
    <h1 className="not-available">
      No Movies avaialble for the selected genre. Please select a different
      genre.
    </h1>
  );
}
